import { configureStore, createSlice } from "@reduxjs/toolkit";
import { authReducer } from "./auth";
import { uiReducer } from "./ui-slice";
import { messageReducer } from "./message";
import { recipeReducer } from "./recipes";
import { promptReducer } from "./prompt";
import { imageReducer } from "./image";
import { ingredientsReducer } from "./ingredients";
import { instructionsReducer } from "./instructions";
import { searchReducer } from "./search";
import { recipeCardReducer } from "./recipeCard";
import { chatbotReducer } from "./chatbot";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "@reduxjs/toolkit";

// import authReducer from "./auth";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import { dishReducer } from "./dishes.js";
import { promptTwoReducer } from "./promptTwo.js";
import { titleReducer } from "./title";
import { cookbookReducer } from "./cookbook";
import { tokensReducer } from "./tokens";

const persistConfig = {
  key: "root",
  storage,
};

const reducers = combineReducers({
  auth: authReducer,
  uiSlice: uiReducer,
  message: messageReducer,
  recipe: recipeReducer,
  prompt: promptReducer,
  promptTwo: promptTwoReducer,
  ingredients: ingredientsReducer,
  image: imageReducer,
  instructions: instructionsReducer,
  search: searchReducer,
  recipeCard: recipeCardReducer,
  dish: dishReducer,
  title: titleReducer,
  tokens: tokensReducer,
  chatbot: chatbotReducer,
  cookbook: cookbookReducer,
});

const persistedReducer = persistReducer(persistConfig, reducers);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
      // serializableCheck: false,
    }),
});

export const persistor = persistStore(store);
